import { useCallback, useEffect, useMemo, useState } from "@wordpress/element";

import axios from "axios";

export default function (config, { manual = false } = {}) {
  const [response, setResponse] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastRequest] = useState({ currentId: 0 });

  const incrReqId = useCallback(function () {
    lastRequest.currentId++;
    return lastRequest.currentId;
  }, []);

  const doRequest = useCallback(
    function (moreConfig = {}) {
      setLoading(true);
      const requestId = incrReqId();
      const totalConfig = { ...config, ...moreConfig };
      axios(totalConfig)
        .then((response) => {
          if (requestId !== lastRequest.currentId) return;
          setLoading(false);
          setResponse(response);
        })
        .catch((err) => {
          if (requestId !== lastRequest.currentId) return;
          setLoading(false);
          setError(err);
        });
    },
    [setLoading, setResponse, setError]
  );

  useEffect(function () {
    if (manual) return;
    doRequest();
  }, []);

  return [
    useMemo(
      function () {
        return { ...response, loading, error };
      },
      [response, loading, error]
    ),
    doRequest,
  ];
}
